<div class="card with-padding no-capture">
  <!-- Row 1: Document Type + Email recipient field -->
  <div style="display: flex; gap: 5px; margin-top: 31px; align-items: center;">
    <div style="flex: 0 0 15%;">
      <mat-form-field appearance="standard" class="compact-form-field" style="width: 100%;">
       <mat-label>Document Type</mat-label>
       <mat-select [(ngModel)]="tranType" name="tranType">
         <mat-option [value]="'invoice'">Invoice</mat-option>
         <mat-option [value]="'status'">Shipment Status</mat-option>
         <mat-option [value]="'pur'">Pickup Requests</mat-option>
         <mat-option [value]="'bol'">Bill of Lading</mat-option>
       </mat-select>
      </mat-form-field>
    </div>
    <div style="flex: 0 0 15%;">
      <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
       <mat-label>Enter the email recipient</mat-label>
       <input matInput [(ngModel)]="email" id="email" name="email" type="text" maxlength="30"/>
      </mat-form-field>
    </div>
  </div>

  <!-- Row 2: Reference # input with Help Button -->
  <div style="display: flex; gap: 5px; margin-top: 2px; align-items: center;">
    <div style="flex: 0 0 60%;">
      <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
        <!-- Conditional Label -->
        <mat-label *ngIf="idType === 'ship'">Enter the Shipment IDs to generate a report for...</mat-label>
        <mat-label *ngIf="idType === 'ref'">Enter the Reference #'s to generate a report for...</mat-label>
        <mat-label *ngIf="idType === 'pro'">Enter the Pros to generate a report for...</mat-label>
        <mat-label *ngIf="tranType === 'invoice'">Enter the Pros to generate a report for...</mat-label>

        <input matInput [(ngModel)]="ids" id="ids" name="ids" type="text"/>
      </mat-form-field>
    </div>
    <div style="flex: 0 0 2%;">
      <button mat-icon-button aria-label="Help" (click)="openHelp('reports')">
      <mat-icon>help_outline</mat-icon>
      </button>
    </div>
  </div>

  <!-- Row 5: ID Type + Generate Report Button -->
  <div style="display: flex; gap: 5px; margin-top: 20px; align-items: center;">
    <div style="flex: 0 0 15%; display: flex; align-items: center;">
      <!-- ID Type - Dynamic options based on document type -->
      <mat-form-field appearance="standard" class="compact-form-field" *ngIf="tranType !== 'invoice'" style="width: 100%;">
        <mat-label>ID Type</mat-label>
        <mat-select [(ngModel)]="idType" name="idType">
          <mat-option [value]="'ref'">Reference#</mat-option>
          <mat-option [value]="'pro'" *ngIf="tranType === 'status'">Pro Number</mat-option>
          <mat-option [value]="'ship'">Shipment ID</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox *ngIf="tranType === 'invoice'" [(ngModel)]="ack" name="ack">include 997 acknowledgements</mat-checkbox>
    </div>
    <div style="flex: 0 0 15%;">
      <button mat-raised-button color="primary" class="xpo-primary-action" (click)="post()">
        <mat-icon>assignment</mat-icon>
        Report
      </button>
    </div>
  </div>

  <!-- Row 6: Reference Code (conditional) -->
  <div style="display: flex; margin-top: 20px;" *ngIf="idType === 'ref' && (tranType === 'status' || tranType === 'pur' || tranType === 'bol')">
    <div style="flex: 0 0 10%;">
      <mat-form-field appearance="fill" class="compact-form-field" style="width: 100%;">
        <mat-label>Reference Code</mat-label>
        <input matInput [(ngModel)]="refCode" id="refCode" name="refCode" type="text"/>
      </mat-form-field>
    </div>
  </div>
</div>
